import React, { Component } from 'react';
import { Button, Popover, Table } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FACTION_BS_VARIANT, FACTION_CSS_COLORS } from '../../../../Constants';
import '../../Controls/automatic-player-controls.css';


class CountDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countDown: 0
        }
    }
    componentDidMount() {
        this.timer = setInterval(this.setCountdown, 250);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.countDown !== this.state.countDown;
    }

    setCountdown = () => {
        this.setState({countDown: this.props.speedController.countDown})
    }

    render() {
        return <span>{('00' + this.state.countDown).slice(-2)}</span>
    }
}

class SpeedControls extends Component {

    constructor(props) {
        super(props);
        this.state = { reRender: 0 };
    }

    reRender = () => {
        this.setState({rerender: this.state.reRender + 1});
    }

    setSpeed = () => {
        this.props.speedController.setSpeed();
        this.reRender();
    };

    belay = () => {
        this.props.speedController.belay();
        this.reRender();
    };
    concur = () => {
        this.props.speedController.concur();
        this.reRender();
    };

    toggleEngagement = () => {
        this.props.speedController.toggleEngagement();
        this.reRender();
    };

    render() {
        const speedController = this.props.speedController;
        const isEngaged = speedController.isEngaged();
        return <div className={'auto-player-buttons'}>

            <div className={'auto-player-button-row'}>

                <div className={'auto-player-button-container'}>
                    {!isEngaged ?
                    <Button
                        variant={this.props.variant}
                        onClick={this.concur}
                        className={'auto-player-button'}
                    >Concur</Button> :
                        <Button
                            variant={this.props.variant}
                            onClick={this.belay}
                            className={'auto-player-button'}
                        >Belay</Button>
                    }
                </div>

                <div className={'auto-player-button-container'}>
                    <div className={'auto-player-button-column'}>
                            {!isEngaged && <div className={'auto-player-button-container'}>
                                <Button
                                    variant={this.props.variant}
                                    onClick={this.toggleEngagement}
                                    className={'auto-player-button'}
                                >Auto</Button>
                            </div>
                            }
                            {isEngaged && <div className={'auto-player-button-container'}>
                                <Button variant={this.props.variant}
                                        onClick={this.setSpeed}
                                        className={'auto-player-button'}
                                >
                                    x{speedController.speedStep + 1}
                                </Button>
                            </div>}

                        {isEngaged && <div className={'auto-player-button-row'}>
                            <div className={'auto-player-button-container'}>
                                <div className={'auto-player-button'}>
                                    <CountDown speedController={this.props.speedController} />
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>;

    }
}


export class AutomaticPlayerControls extends Component {

    constructor(props) {
        super(props);
        this.state = {reRenderCounter: 0}
        this.lastModified = null;
    }

    componentDidMount() {
        window.addEventListener('artificial-player-update-event',
            this.updateListener);
    }

    componentWillUnmount() {
        window.removeEventListener('artificial-player-update-event',
            this.updateListener);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.hasChanged();
    }

    hasChanged = () => {
        const artificialPlayer = this.props.app.game.seatedController.artificialPlayer;
        return this.lastModified !== JSON.stringify(artificialPlayer.modified);
    }

    updateListener = () => {
        if (this.hasChanged()) this.setState(
            {reRenderCounter: ++this.state.reRenderCounter});
    }

    render() {
        const seatedController = this.props.app.game.seatedController
        const artificialPlayer = seatedController.artificialPlayer;
        const gamePlayerData = seatedController.gamePlayerData;
        if (!gamePlayerData) return <></>;
        this.lastModified = JSON.stringify(artificialPlayer.modified);
        const variant = FACTION_BS_VARIANT[gamePlayerData.captain];
        let color = FACTION_CSS_COLORS[gamePlayerData.captain];
        if (color === 'var(--deep)') color = 'white';
        const aiPackage = artificialPlayer.currentAIPackage;
        if (!aiPackage) return <></>
        if (aiPackage.message === '' || aiPackage.message === '.') {
            console.error('Something was missed.')
        }

        const placement = 'bottom';
        return <div id={'auto-player'}>
            <div id={'auto-player-controls'}
                 className={'auto-player-controls'}>
                <div id={'statement-block'} className={'auto-player-statement-block'}>
                    <OverlayTrigger
                        key={placement}
                        placement={placement}
                        trigger={'click'}
                        overlay={
                            <Popover id={`provenance-popover`}>
                                <Popover.Header as="h3">
                                    <strong>Provenance</strong>
                                </Popover.Header>
                                <Popover.Body>
                                    <div className={'popover-table-container'}>
                                        <Table>
                                            <thead/>
                                            <tbody>
                                            {aiPackage.provenance.map((row, index) => {
                                                return <tr key={index}>
                                                    <td>{row.question}</td>
                                                    <td>{row.answer}</td>
                                                    <td>{row.reason}</td>
                                                </tr>;
                                            })}
                                            </tbody>

                                        </Table>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <div className={'auto-player-statement'} style={{ color: color }}>
                            Captain {aiPackage.name} proposes: {aiPackage.message}
                        </div>
                    </OverlayTrigger>

                </div>
                <div id={'control-block'} className={'auto-player-control-block'}>
                    <SpeedControls
                        speedController={artificialPlayer.speedController}
                        variant={variant}
                    />
                </div>
            </div>

        </div>;
    }
}
